<template>
  <div class="statistics">

    <div class="row">
      <div class="key">提出数:</div>
      <div class="val">{{ statistics.num }}</div>
    </div>
    <div class="row">
      <div class="key">商品金额:</div>
      <div class="val">{{ statistics.amount.toFixed(2) }}</div>
    </div>
    <div class="row">
      <div class="key">标签数:</div>
      <div class="val">{{ statistics.tag }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    checkedList: { type: Array },

  },
  computed: {
    statistics() {
      let total = {
        num: 0,
        amount: 0,
        tag: 0,
      }
      this.checkedList.forEach(item => {
        // console.log(item);
        total.num += item.num - 0
        total.amount += item.num * item.confirm_price
        item.porder_detail_tag.forEach(items => {
          total.tag += items.num - 0
        })

      })


      return total
    }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 60px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}

/deep/.el-popover {
  background-color: pink !important;
}
</style>